import {withStyles} from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';

const StyledTableRow = withStyles((theme) => ({
  root: (props) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: props.disableColor
        ? theme.palette.common.white
        : '#D9ECF7',
    },
    backgroundColor: theme.palette.common.white,
  }),
}))(TableRow);

export default StyledTableRow;
